<div class="d-flex flex-column">
  <div class="page-background" [class.slate-bck]="slateBackground">
    @if (showPageHeader) {
      <app-page-header-public-alt [isLanding]="isLanding" [isTopBannerVisible]="isTopBannerVisible"/>
    }
    <div class="position-relative page-content" [style.min-height]="contentHeight" [class.no-page-header]="!showPageHeader">
      <ng-content></ng-content>
    </div>
  </div>
</div>

@if (showFooter) {
  <app-footer [displayLargeMobileFooter]="displayLargeMobileFooter"/>
}
<ng-content select="[slot='footer']"></ng-content>
